export class MainConfig {

    static readonly CLASS_NAME = 'MainConfig';
    static readonly WARNING = `Missing MainConfig in profile configuration.
             That' okay if you are building to integrate
             web components into an other app. If you
             are building a full app with KTA20 instead,
             you must include a MainConfig in your profile
             config so that the app knows what it is the
             main entry point component of the app.`;

    name=MainConfig.CLASS_NAME;

    constructor(public entryPointName:string, public options:any) {
    }

}